module.exports = __webpack_public_path__ + "static/media/on-eye_classic-Natural.1c3fdbf4.jpg";